import dayjs from "../../../utils/dayjs";
import { daysJsFormat as datesFormats } from "../../../utils/constants";
import { Popover, Space, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { http } from "../../../engine/api/http";
import { FaCheckCircle } from "react-icons/fa";
import { BiSolidErrorCircle } from "react-icons/bi";
import { t } from "i18next";
import { isSuperAdmin } from "../../../engine/hooks/hooks.helpers";

export const RenderlastSent = ({ bill }) => {
  const { t } = useTranslation();

  const sentEmails = JSON.parse(JSON.stringify(bill?.sentEmails || []));

  const renderEmail = sent => {
    return (
      <span style={{ color: "#636363" }}>
        <b>{t("BillHeader.sentAt")} </b>{" "}
        {dayjs(sent.date).format(datesFormats.full)} :
        {sent.tos.map(t => t).join(", ")}
      </span>
    );
  };

  if (sentEmails.length > 0) {
    const last = sentEmails.sort(
      (a, b) => new Date(b.date) - new Date(a.date),
    )[0];

    return (
      <Popover
        content={
          <Space direction={"vertical"}>
            {sentEmails.map(e => renderEmail(e))}
          </Space>
        }
        title={t("BillHeader.historique")}
      >
        <InfoCircleOutlined />{" "}
        <span style={{ color: "#636363" }}>
          <b>{t("BillHeader.lastSent")} </b>{" "}
          {dayjs(last.date).format(datesFormats.full)}
        </span>
      </Popover>
    );
  } else {
    return <div>{t("BillHeader.neverDent")}</div>;
  }
};
export const RenderlastDownload = ({ bill, loadOnInit = false }) => {
  const { t } = useTranslation();
  const [populated, setPopulated] = React.useState(false);

  const populatedData = async first => {
    try {
      const { data } = await http.get(
        `bills/${bill._id}/downloaded?first=true`,
      );

      setPopulated(data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (loadOnInit) {
      populatedData();
    }
  }, []);

  const renderEmail = sent => {
    return (
      <span style={{ color: "#636363" }}>
        <b>{t("BillHeader.downloadedAt")} </b>{" "}
        {dayjs(sent.at).format(datesFormats.full)} : {sent.user.email} -{" "}
        {t(`roles.${sent.user.role}`)}
      </span>
    );
  };

  if (populated.length > 0) {
    const last = populated.sort((a, b) => new Date(b.at) - new Date(a.at))[0];

    return (
      <Popover
        onOpenChange={v => {
          if (v && populated === false) {
            populatedData();
          }
        }}
        content={
          <Space direction={"vertical"}>
            {populated === false ? (
              <Spin />
            ) : (
              <> {populated.map(e => renderEmail(e))}</>
            )}
          </Space>
        }
        title={
          <>
            {t("BillHeader.historique")} ({populated.length})
          </>
        }
      >
        <InfoCircleOutlined />{" "}
        <span style={{ color: "#636363" }}>
          <b>{t("BillHeader.lastDownload")} </b>{" "}
          {dayjs(last.at).format(datesFormats.full)}
        </span>
      </Popover>
    );
  } else {
    return <div>{t("BillHeader.neverDownloaded")}</div>;
  }
};
